import { defineMessages } from 'react-intl-next';

export const messages: {
    addFrameText: {
        defaultMessage: string;
        description: string;
        id: string;
    }; contentTabLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; framesInvalidMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    }; preambleSupportLinkLabelV2: {
        defaultMessage: string;
        description: string;
        id: string;
    }; preambleV2: {
        defaultMessage: string;
        description: string;
        id: string;
    }; preambleV2WithoutSupportLink: {
        defaultMessage: string;
        description: string;
        id: string;
    }; styleSectionGeneralTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    }; styleSectionNavigationTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    }; stylesTabLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; title: {
        defaultMessage: string;
        description: string;
        id: string;
    }; updatedLozengeLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	title: {
		id: 'company-hub.carousel-extension.config-panel.title',
		defaultMessage: 'Carousel',
		description: 'A visible text label to be used as the title for the carousel config panel',
	},
	framesInvalidMessage: {
		id: 'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list',
		defaultMessage: 'Add frames',
		description:
			'Message for error shown to user when a value for frames is not provided or is invalid',
	},
	preambleV2: {
		id: 'company-hub.carousel-extension.config-panel.preamble-v2',
		defaultMessage: 'Design a set of up to {number} rotating frames. {supportLink}',
		description: 'General helper text in Company hub configuration panel',
	},
	preambleV2WithoutSupportLink: {
		id: 'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link',
		defaultMessage: 'Design a set of up to {number} rotating frames.',
		description: 'General helper text in Company hub configuration panel without support link',
	},
	preambleSupportLinkLabelV2: {
		id: 'company-hub.carousel-extension.config-panel.preamble-link.label-v2',
		defaultMessage: 'Learn more about carousels',
		description:
			'Link text to learn more about carousel. Located in the general helper text in carousel config panel',
	},
	stylesTabLabel: {
		id: 'company-hub.carousel-extension.config-panel.tab.styles.label',
		defaultMessage: 'Styles',
		description: 'Label for the styles tab shown in the carousel config panel, where clicking on it will open the styles section to configure the styles of the carousel',
	},
	contentTabLabel: {
		id: 'company-hub.carousel-extension.config-panel.tab.content.label',
		defaultMessage: 'Content',
		description: 'Label for the content tab shown in the carousel config panel, where clicking on it will open the content section to configure the content of the carousel',
	},
	styleSectionGeneralTitle: {
		id: 'company-hub.carousel-extension.config-panel.style.general.title',
		defaultMessage: 'General',
		description: 'Title for the general style section in the carousel config panel',
	},
	styleSectionNavigationTitle: {
		id: 'company-hub.carousel-extension.config-panel.style.navigation.title',
		defaultMessage: 'Navigation',
		description: 'Title for the navigation style section in the carousel config panel',
	},
	addFrameText: {
		id: 'company-hub.carousel-extension.config-panel.add-frame-cta',
		defaultMessage: 'Add frame',
		description: 'Button that allows the user to add a new frame to their carousel extension',
	},
	updatedLozengeLabel: {
		id: 'company-hub.carousel-extension.config-panel.lozenge.label.updated',
		defaultMessage: 'UPDATED',
		description: 'A label indicating that this feature has been updated',
	},
});
